export interface FloorPlateData {
	pendingResidences: boolean;
	floorplateId: string;
	displayName: string;
	svgUrl: string;
	elevation: string;
	residences: CMSResidence[];
}

export interface CMSResidence {
	svgId: string;
	name: string;
	planInfo: string;
	roomsSummary: string;
	areaRange: string;
	floorplateImgSrc: string;
	floorplateImgAlt: string;
	floorplans: CMSFloorplan[];
}

export interface CMSFloorplan {
	name: string;
	type: string;
	floorplanImgSrc: string;
	floorplanImgAlt: string;
	beds?: string;
	baths?: string;
	interiorArea?: string;
	exteriorArea?: string;
	levels?: string;
}

export function fetchResidenceData(languageCode: string, floorplate: FloorPlateData): Promise<boolean> {
	const langPrefix: string = languageCode ? `/${languageCode}` : '';
	const url: string = `${langPrefix}/wp-json/v1/floorplate/${floorplate.floorplateId}`;
	console.log(url);
	return new Promise((resolve) => {
		fetch(url)
			.then((response) => response.json())
			.then((json) => {
				json.residences.forEach((entry: any, _index: number) => {
					let floorplans: CMSFloorplan[] = [];
					if (entry.floorplans && Array.isArray(entry.floorplans)) {
						entry.floorplans.forEach((fp: any) => {
							let floorplan: CMSFloorplan = {
								name: fp.plan_name,
								type: fp.plan_type,
								floorplanImgSrc: fp.image,
								floorplanImgAlt: fp.image_alt,
								beds: fp.bedrooms,
								baths: fp.bathrooms,
								interiorArea: fp.interior_sqft,
								exteriorArea: fp.exterior_sqft,
								levels: fp.levels,
							};
							floorplans.push(floorplan);
						});
					}
					let residence: CMSResidence = {
						svgId: entry.residence_id,
						name: entry.display_name,
						planInfo: entry.plan_info,
						roomsSummary: entry.summary,
						areaRange: entry.sqft_range,
						floorplateImgSrc: entry.floorplate_thumbnail,
						floorplateImgAlt: entry.floorplate_thumbnail_alt,
						floorplans: floorplans,
					};
					floorplate.residences.push(residence);
				});
				resolve(true);
			})
			.catch((error) => {
				console.error('Error loading SVG:', error);
				resolve(false);
			});
	});
}

export function parseFloorPlateData(floorplateElements: NodeListOf<HTMLElement>, floorplateDatas: FloorPlateData[]): void {
	const attr = (element: HTMLElement, attrName: string): string => {
		return element.getAttribute(attrName) || '';
	};
	floorplateElements?.forEach((floorplateEl: HTMLElement) => {
		const item: FloorPlateData = {
			floorplateId: attr(floorplateEl, 'floorplate-id') || '',
			displayName: attr(floorplateEl, 'display-name') || '',
			svgUrl: attr(floorplateEl, 'overlay') || '',
			elevation: attr(floorplateEl, 'elevation') || '',
			residences: [],
			pendingResidences: true,
		};
		floorplateDatas.push(item);
	});
}
